import { Suspense, lazy } from 'react';
import Loader from 'wrapper/loader';
import Login from '@/pages/shared/auth/login/Login';
import MiraUnifiedLogin from '@/pages/shared/auth/login/MiraUnifiedLogin';
import NotFound from 'components/404';
import SessionExpire from 'wrapper/session-expire/SessionExpire';
import InviteExpire from 'wrapper/invite-expire';
import EmailVerified from 'wrapper/email-verified';
import VerifyPassword from '@/pages/shared/auth/verify-password';
import OAuthCallback from '@/pages/shared/auth/oauth/OAuthCallback';
import CompanyOnboarding from '@/pages/b2b/onboarding/CompanyOnboarding';

const PlatformLogin = lazy(() => import('@/pages/platform/PlatformLogin'));
const SubdomainDemo = lazy(() => import('@/pages/shared/demo/SubdomainDemo'));

export const authRoutes = [
  {
    path: '/auth/callback',
    element: (
      <Suspense fallback={<Loader />}>
        <OAuthCallback />
      </Suspense>
    ),
  },
  {
    path: '/branch/auth/callback',
    element: (
      <Suspense fallback={<Loader />}>
        <OAuthCallback />
      </Suspense>
    ),
  },
  {
    path: '/onboard',
    element: (
      <Suspense fallback={<Loader />}>
        <CompanyOnboarding />
      </Suspense>
    ),
  },
  {
    path: '/platform/login',
    element: (
      <Suspense fallback={<Loader />}>
        <PlatformLogin />
      </Suspense>
    ),
  },
  {
    // Every entry point is the specialist one now. There is no borrower login:
    // the B2B operator drives the whole file, so a "Home Buyer" sign-in leads
    // nowhere. `buyer` also short-circuits the auth path inside
    // MiraUnifiedLogin, so leaving it as the default meant the most obvious URL
    // in the product opened a form that could not sign anybody in.
    path: '/login',
    element: (
      <Suspense fallback={<Loader />}>
        <MiraUnifiedLogin initialUserType="specialist" />
      </Suspense>
    ),
  },
  {
    path: '/login/b2b',
    element: (
      <Suspense fallback={<Loader />}>
        <MiraUnifiedLogin initialUserType="specialist" />
      </Suspense>
    ),
  },
  {
    path: '/',
    element: <Login />,
    children: [
      {
        index: true,  // the bare domain is the specialist login
        element: (
          <Suspense fallback={<Loader />}>
            <MiraUnifiedLogin initialUserType="specialist" />
          </Suspense>
        ),
      },
      // `login/consumer` and `account-selection` are gone. The first was the
      // borrower's sign-in; the second asked which of the two you were, a
      // question with one answer now.
      {
        path: 'setup-password',
        element: (
          <Suspense>
            <VerifyPassword />
          </Suspense>
        ),
      },
      {
        path: 'session-timeout',
        element: (
          <Suspense>
            <SessionExpire />
          </Suspense>
        ),
      },
      {
        path: 'verified',
        element: (
          <Suspense>
            <InviteExpire />
          </Suspense>
        ),
      },
      {
        path: 'result_page',
        element: (
          <Suspense>
            <EmailVerified />
          </Suspense>
        ),
      },
      {
        path: 'demo/subdomain',
        element: (
          <Suspense fallback={<Loader />}>
            <SubdomainDemo />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: (
          <Suspense>
            <NotFound />
          </Suspense>
        ),
      },
    ],
  },
];
